import DOMPurify from 'dompurify';
import endpoints from '../../shared/constants/endpoints';

export const NEWSROOM_TITLE = 'Newsroom | Insomnia Cookies';
export const NEWSROOM_DESCRIPTION =
  'The latest Insomnia Cookies news: new store openings, product launches, press releases, images and video.';

export const MEDIA_SECTIONS = [
  { slug: 'images', type: 'IMAGE', title: 'Images', thumbnailKey: 'images' },
  { slug: 'news', type: 'NEWS', title: 'In the News', thumbnailKey: 'news' },
  { slug: 'videos', type: 'VIDEO', title: 'Videos', thumbnailKey: 'videos' },
];

export const getMediaSection = slug => MEDIA_SECTIONS.find(section => section.slug === slug);

export const articlePath = slug => `${endpoints.news}/${slug}`;

export const mediaPath = slug => `${endpoints.newsMedia}/${slug}`;

export const formatNewsDate = value => {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value || '');
  if (!match) {
    return '';
  }
  const [, year, month, day] = match;
  return new Date(Number(year), Number(month) - 1, Number(day)).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
};

let hooksRegistered = false;

const registerHooks = () => {
  if (hooksRegistered) {
    return;
  }
  DOMPurify.addHook('afterSanitizeAttributes', node => {
    if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
      node.setAttribute('rel', 'noopener noreferrer');
    }
  });
  hooksRegistered = true;
};

export const sanitizeNewsHtml = html => {
  registerHooks();
  return DOMPurify.sanitize(html || '', {
    FORBID_TAGS: ['style', 'script', 'iframe', 'form', 'input', 'button'],
    FORBID_ATTR: ['style', 'class', 'id', 'width', 'height'],
    ADD_ATTR: ['target'],
  });
};

export const buildShareLinks = (url, title) => {
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);
  return [
    { label: 'X', href: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}` },
    { label: 'Facebook', href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}` },
    { label: 'LinkedIn', href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}` },
  ];
};

export const parseListParams = search => {
  const params = new URLSearchParams(search);
  const page = parseInt(params.get('page'), 10);
  return {
    q: (params.get('q') || '').trim(),
    page: Number.isNaN(page) || page < 1 ? 1 : page,
  };
};

export const buildListSearch = ({ q, page }) => {
  const params = new URLSearchParams();
  if (q) {
    params.set('q', q);
  }
  if (page && page > 1) {
    params.set('page', String(page));
  }
  const value = params.toString();
  return value ? `?${value}` : '';
};
